import gql from "graphql-tag";

/**
 * @param {string} - hospitalName
 */
export const SUBSCRIBE_HOSPITAL_REPORT_LIST_BY_HOSPITAL_NAME = gql`
  subscription fetchHospitalReportListByHospitalName($hospitalName: String!) {
    hospitalReport(
      where: { hospitalReport_hospital: { name: { _eq: $hospitalName } } }
      order_by: { dateStamp: asc }
    ) {
      dateStamp
      icuBedsSuspectedCovid
      id
      negativePatientTests
      numberOfCalls
      patientsAdmittedSuspectedCovid
      patientsTested
      positivePatientTests
      wardBedsSuspectedCovid
    }
  }
`;
